import React from "react";
import S3Uploader from "./S3Uploader";
import "./Uploader.css";

export default function Uploader({ conf, title, uploadText, helper }) {
  return (
    <div className="Uploader">
      <h3>{title}</h3>
      <span className="helper">{helper}</span>
      <S3Uploader text={uploadText} conf={conf} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Uploader.js